<template>
  <div>
    <gatherBasis :cells="cells" :type="type">
      <template #column>
        <el-table-column align="center" header-align="center" label="检查人数" prop="checkCount" width="150px"/>
        <el-table-column align="center" header-align="center" label="正常">
          <el-table-column align="center" header-align="center" label="人数" prop="normal"/>
          <el-table-column align="center" header-align="center" label="百分比" prop="normalRatio"/>
        </el-table-column>
        <el-table-column v-for="item in cells" :label="item.name" align="center" header-align="center">
          <el-table-column :prop="item.prop" align="center" header-align="center" label="人数"/>
          <el-table-column :prop="item.prop+'Ratio'" align="center" header-align="center" label="百分比"/>
        </el-table-column>

      </template>
    </gatherBasis>
  </div>

</template>
<script>
import gatherBasis from "../components/gatherBasis.vue"
/*体重指标*/
export default {
  name: "gatherWeightMark",
  components: {
    gatherBasis
  },
  data() {
    return {
      type: "weightMark",
      cells: [
        {prop: "r037", name: '轻度低体重'},
        {prop: "r038", name: '中度低体重'},
        {prop: "r039", name: '重度低体重'}
      ]
    }
  },
  mounted() {
  },
  methods: {}
}
</script>
<style scoped>

</style>